import { yupResolver } from "@hookform/resolvers/yup";
import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { ALL_STORE } from "constants/DashboardContanst";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import { formConvertErrorMessage, formValidate } from "helpers/form_helper";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { Controller, useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MetaTags } from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Label,
  Row,
  Table,
} from "reactstrap";
import {
  createErrorInvoices,
  editErrorInvoices,
  listNotificationPropertiesErrorInvoices,
  listTypeInvoiceErrorInvoices,
  resetCreateErrorInvoices,
  resetEditErrorInvoices,
  resetListNotificationPropertiesErrorInvoices,
  resetListTypeInvoiceErrorInvoices,
} from "store/actions";
import * as yup from "yup";
import SearchInvoiceTaxDeduct from "./SearchInvoiceTaxDeduct";
import {
  convertDate,
  errorInvoicesLoaiThongBao,
  KyHieuMauCTUList,
  KyHieuMauHoaDonList,
  MODE,
} from "./utils";

const CreateErrorTaxDeduct = props => {
  const { isTaxDeduct = true, detailData = null, toggleDetail } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["errorInvoice"]);
  const { t: tt } = useTranslation(["requestInvoiceCode"]);
  const { addToast } = useToasts();

  const isDisableForm = detailData && detailData.mode === MODE.VIEW;

  const Dashboard = useSelector(state => state.Dashboard);
  const { buTenantHeaderInfo, buStoreHeader, tenantCodeHeader, finalBuInfo } =
    Dashboard;

  const errorInvoices = useSelector(state => state.errorInvoices);
  const {
    loadingListTypeInvoice,
    errorListTypeInvoice,
    listTypeInvoice: errorInvoicesListTypeInvoice,

    loadingListNotificationProperties,
    errorListNotificationProperties,
    listNotificationProperties: errorInvoicesListNotificationProperties,

    loadingCreate,
    errorCreate,
    create: errorInvoicesCreate,

    loadingEdit,
    errorEdit,
    edit: errorInvoicesEdit,
  } = errorInvoices;

  // Search Invoice Modal
  const [dataSearchInvoice, setDataSearchInvoice] = useState([]);
  const [searchInvoiceModal, setSearchInvoiceModal] = useState(false);
  const [displaySearchInvoice, setDisplaySearchInvoice] = useState(false);

  // dataChangeInfo Modal
  const [dataChangeInfo, setDataChangeInfo] = useState({});
  const [changeInfoModal, setChangeInfoModal] = useState(false);
  const toggleChangeInfoModal = () => {
    setChangeInfoModal(!changeInfoModal);
  };

  // Show / Hide Field Thông Báo
  const [displayThongBao, setDisplayThongBao] = useState(false);

  let schema = yup.object().shape({
    is_thong_bao: yup.boolean(),
    is_loai_hoa_don: yup.boolean(),
    loai_hoa_don: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_hoa_don") })),
    loai_thong_bao: yup
      .object()
      .required(t("form.validate.select", { title: t("form.loai_thong_bao") })),
    so_thong_bao: yup.string().when("is_thong_bao", {
      is: true,
      then: yup
        .string()
        .required(
          t("form.validate.required", { title: t("form.so_thong_bao") })
        ),
    }),
    ngay_thong_bao: yup.array().when("is_thong_bao", {
      is: true,
      then: yup
        .array()
        .min(1, t("form.validate.select", { title: t("form.ngay_thong_bao") })),
    }),
    lines: yup.array().when("is_loai_hoa_don", {
      is: true,
      then: yup
        .array()
        .min(
          1,
          isTaxDeduct
            ? t("form.validate.least_one_line_tax_deduct")
            : t("form.validate.least_one_line")
        )
        .of(
          yup.object().shape({
            id_invoice: yup.string().nullable(),
            ma_cqt_cap: yup
              .string()
              // .required(
              //   t("form.validate.required", { title: t("form.ma_cqt_cap") })
              // )
              .nullable(),
            khmhdon: yup
              .object()
              .required(
                t("form.validate.select", { title: t("form.khmhdon") })
              ),
            khhdon: yup.string().required(
              t("form.validate.required", {
                title: isTaxDeduct ? t("form.khctu") : t("form.khhdon"),
              })
            ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", {
                  title: isTaxDeduct ? t("form.sctu") : t("form.so_hoa_don"),
                })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup.array().min(
              1,
              t("form.validate.select", {
                title: isTaxDeduct
                  ? t("form.ngay_lap_ctu")
                  : t("form.ngay_lap_hdon"),
              })
            ),
            tchat_thong_bao: yup.object().test(
              "tchat_thong_bao",
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              }),
              value => (isTaxDeduct ? true : value !== undefined)
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
      otherwise: yup
        .array()
        .min(
          1,
          isTaxDeduct
            ? t("form.validate.least_one_line_tax_deduct")
            : t("form.validate.least_one_line")
        )
        .of(
          yup.object().shape({
            ma_cqt_cap: yup.string().nullable(),
            khmhdon: yup.object().required(
              t("form.validate.select", {
                title: isTaxDeduct ? t("form.khmctu") : t("form.khmhdon"),
              })
            ),
            khhdon: yup.string().required(
              t("form.validate.required", {
                title: isTaxDeduct ? t("form.khctu") : t("form.khhdon"),
              })
            ),
            // .max(6, t("form.validate.char_max", { max: 6 })),
            so_hoa_don: yup
              .string()
              .required(
                t("form.validate.required", {
                  title: isTaxDeduct ? t("form.sctu") : t("form.so_hoa_don"),
                })
              )
              .matches(/^[0-9]+$/, t("form.validate.integer")),
            // .max(20, t("form.validate.integer_max", { max: 20 })),
            ngay_lap_hdon: yup.array().min(
              1,
              t("form.validate.select", {
                title: isTaxDeduct
                  ? t("form.ngay_lap_ctu")
                  : t("form.ngay_lap_hdon"),
              })
            ),
            tchat_thong_bao: yup.object().test(
              "tchat_thong_bao",
              t("form.validate.select", {
                title: t("form.tchat_thong_bao"),
              }),
              value => (isTaxDeduct ? true : value !== undefined)
            ),
            ly_do: yup
              .string()
              .required(
                t("form.validate.required", { title: t("form.ly_do") })
              ),
          })
        ),
    }),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      is_thong_bao: false,
      is_loai_hoa_don: true,
      loai_hoa_don: undefined,
      loai_thong_bao: undefined,
      so_thong_bao: "",
      ngay_thong_bao: [],
      lines: [],
    },
  });

  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: "lines", // unique name for your Field Array
      keyName: "key", // keyName: "id", default to "id", you can change the key name
    }
  );

  // Set Default Values
  useEffect(() => {
    const findLoaiThongBao = errorInvoicesLoaiThongBao.find(
      item => item.key === "type1"
    );
    if (findLoaiThongBao) {
      setValue("loai_thong_bao", {
        value: findLoaiThongBao.value,
        label: findLoaiThongBao.label,
      });
    }
  }, []);

  // Get List Data For Select
  useEffect(() => {
    dispatch(listTypeInvoiceErrorInvoices({ isTaxDeduct }));
    // if (!isTaxDeduct) {
    dispatch(listNotificationPropertiesErrorInvoices());
    // }
    return () => {
      dispatch(resetListTypeInvoiceErrorInvoices());
      dispatch(resetListNotificationPropertiesErrorInvoices());
    };
  }, [dispatch]);

  // Action Dispatch
  useEffect(() => {
    if (errorInvoicesCreate && errorInvoicesCreate.success) {
      addToast(
        t("message.create", {
          target: isTaxDeduct ? t("error_tax_deduct") : t("error_invoice"),
          status: t("message.success"),
        }),
        {
          appearance: "success",
          autoDismiss: true,
        }
      );
      dispatch(resetCreateErrorInvoices());
      if (isTaxDeduct) {
        history.push("/error-tax-deducts");
      } else {
        history.push("/error-invoices");
      }
    }
  }, [addToast, dispatch, errorInvoicesCreate, history, toggleDetail, t]);

  // Error Dispatch
  useEffect(() => {
    if (errorListTypeInvoice) {
      addToast(
        formConvertErrorMessage(
          errorListTypeInvoice.message ||
            t("message.list", {
              target: t("type_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListTypeInvoiceErrorInvoices());
    }

    if (errorListNotificationProperties) {
      addToast(
        formConvertErrorMessage(
          errorListNotificationProperties.message ||
            t("message.list", {
              target: t("notification_properties"),
              status: t("message.error"),
            }),
          t
        ),
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
      dispatch(resetListNotificationPropertiesErrorInvoices());
    }

    if (errorCreate) {
      addToast(
        formConvertErrorMessage(
          errorCreate.message ||
            t("message.create", {
              target: isTaxDeduct ? t("error_tax_deduct") : t("error_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        { appearance: "error", autoDismiss: true }
      );
      if (errorCreate.code === 422 && errorCreate.fields.length > 0) {
        errorCreate.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, {
            type: "manual",
            message: formConvertErrorMessage(item.message, t),
          });
        });
      }
      dispatch(resetCreateErrorInvoices());
    }

    if (errorEdit) {
      addToast(
        formConvertErrorMessage(
          errorEdit.message ||
            t("message.edit", {
              target: isTaxDeduct ? t("error_tax_deduct") : t("error_invoice"),
              status: t("message.error"),
            }),
          t
        ),
        { appearance: "error", autoDismiss: true }
      );
      if (errorEdit.code === 422 && errorEdit.fields.length > 0) {
        errorEdit.fields.map(item => {
          let fieldName = item.field;
          switch (item.field) {
            case "common":
              addToast(item.message, {
                appearance: "error",
                autoDismiss: true,
              });
              break;
            default:
              break;
          }
          setError(fieldName, {
            type: "manual",
            message: formConvertErrorMessage(item.message, t),
          });
        });
      }
      dispatch(resetEditErrorInvoices());
    }
  }, [
    addToast,
    dispatch,
    errorCreate,
    errorEdit,
    errorListNotificationProperties,
    errorListTypeInvoice,
    setError,
    t,
  ]);

  const toggleSearchInvoiceModal = (action = "") => {
    setSearchInvoiceModal(!searchInvoiceModal);
    switch (action) {
      case "change":
        // Clear Main Template Version After Selected New List
        // setValue("main_template_version_id", "", { shouldValidate: true });
        break;
      default:
        break;
    }
  };

  const checkThongBaoHandler = loaiThongBao => {
    const valueLoaiThongBao = loaiThongBao;
    if (valueLoaiThongBao !== undefined) {
      switch (valueLoaiThongBao.value) {
        case "1":
          setDisplayThongBao(false);
          setValue("is_thong_bao", false);
          break;
        case "2":
          setDisplayThongBao(true);
          setValue("is_thong_bao", true);
          break;
        default:
          break;
      }
    }
  };

  const checkLoaiHoaDonHandler = loaiHoaDon => {
    const valueLoaiHoaDon = loaiHoaDon;

    setValue("lines", [], { shouldValidate: true });

    if (valueLoaiHoaDon !== undefined) {
      switch (Number(valueLoaiHoaDon.value)) {
        case 1:
          setValue("is_loai_hoa_don", true);
          setDisplaySearchInvoice(true);
          break;
        default:
          addNewLine();
          setValue("is_loai_hoa_don", false);
          setDisplaySearchInvoice(false);
          break;
      }
    }
  };

  const addNewLine = (dataReplace = null) => {
    append(
      dataReplace || {
        id_invoice: null,
        ma_cqt_cap: "",
        khmhdon: undefined,
        khhdon: "",
        so_hoa_don: "",
        ngay_lap_hdon: [],
        tchat_thong_bao: undefined,
        ly_do: "",
      }
    );
  };

  const onSubmit = values => {
    // toggleTypeSignModal();
    // setTransferData(values);
    callApi(values);
  };

  const onErrorInvoice = values => {
    console.log("🚀 ~ onErrorInvoice ~ values:", values);
  };

  const removeDataSearchInvoice = index => {
    const lineMustRemove = getValues(`lines.${index}`);
    const filterDataSearchInvoice = dataSearchInvoice.filter(
      item => item.id !== lineMustRemove.id_invoice
    );
    setDataSearchInvoice(filterDataSearchInvoice);
  };

  const callApi = values => {
    // const values = transferData;
    const dataCreate = {
      loai: values.loai_thong_bao.value,
      ladhddt: values.loai_hoa_don.value,
    };
    if (getValues("is_thong_bao")) {
      dataCreate["ntbccqt"] = convertDate(values.ngay_thong_bao[0], "date");
      dataCreate["so"] = Number(values.so_thong_bao);
    }
    if (isTaxDeduct) {
      dataCreate.lctdt = values.loai_hoa_don.value;
      dataCreate.dsctu = values.lines.map(item => {
        return {
          ID: item.id_invoice || null,
          KHMSCTu: item.khmhdon.value,
          KHCTu: item.khhdon,
          SCTu: Number(item.so_hoa_don),
          NLap: convertDate(item.ngay_lap_hdon[0], "date"),
          LCTDT: values.loai_hoa_don.value,
          LDo: item.ly_do,
        };
      });
    }
    // Tạo thông báo
    if (!detailData) {
      dispatch(createErrorInvoices({ ...dataCreate }));
    } else {
      // Cập nhật thông báo
      dispatch(editErrorInvoices({ ...dataCreate }, detailData.id));
    }
  };

  const optionLoaiHoaDon =
    errorInvoicesListTypeInvoice?.items?.map(item => ({
      value: String(item.id),
      label: item.value,
    })) || [];

  const tableTaxDeduct = (
    <Table className="table table-bordered">
      <thead>
        <tr>
          <th className="text-center" style={{ width: "20px" }}>
            STT
          </th>
          <th>Ký hiệu mẫu và ký hiệu chứng từ</th>
          <th>Số chứng từ</th>
          <th>Ngày lập chứng từ</th>
          <th>Lý do</th>
          <th style={{ width: "20px" }}></th>
        </tr>
      </thead>
      <tbody>
        {fields.map((field, index) => {
          return (
            <tr key={field.key}>
              <td>{index + 1}</td>
              <td>
                <Row className="row-cols-1 row-cols-lg-2">
                  <Col>
                    <Controller
                      control={control}
                      name={`lines.${index}.khmhdon`}
                      render={({ field }) => (
                        <CreatableSelect
                          {...field}
                          isDisabled={displaySearchInvoice || isDisableForm}
                          placeholder={t("placeholder.select", {
                            title: t("form.khmctu"),
                          })}
                          options={
                            KyHieuMauCTUList && KyHieuMauCTUList.length > 0
                              ? KyHieuMauCTUList.map(item => ({
                                  value: item.value,
                                  label: item.label,
                                }))
                              : []
                          }
                          classNamePrefix="select2-selection"
                        />
                      )}
                    />
                    {errors.lines &&
                      errors.lines[index] &&
                      errors.lines[index].khmhdon && (
                        <MessageFormValidate
                          error={errors.lines[index].khmhdon.message}
                        />
                      )}
                  </Col>
                  <Col>
                    <Controller
                      control={control}
                      name={`lines.${index}.khhdon`}
                      render={({ field }) => (
                        <input
                          {...field}
                          disabled={displaySearchInvoice || isDisableForm}
                          type="text"
                          className={`form-control ${formValidate(
                            errors,
                            touchedFields,
                            `lines.${index}.khhdon`
                          )}`}
                          onChange={data => {
                            field.onChange(data.target.value.toUpperCase());
                          }}
                          placeholder={t("placeholder.enter", {
                            title: t("form.khctu"),
                          })}
                        />
                      )}
                    />
                    {errors.lines &&
                      errors.lines[index] &&
                      errors.lines[index].khhdon && (
                        <MessageFormValidate
                          error={errors.lines[index].khhdon.message}
                        />
                      )}
                  </Col>
                </Row>
              </td>
              <td>
                <input
                  disabled={displaySearchInvoice || isDisableForm}
                  type="number"
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    `lines.${index}.so_hoa_don`
                  )}`}
                  placeholder={t("placeholder.enter", {
                    title: t("form.sctu"),
                  })}
                  {...register(`lines.${index}.so_hoa_don`)}
                />
                {errors.lines &&
                  errors.lines[index] &&
                  errors.lines[index].so_hoa_don && (
                    <MessageFormValidate
                      error={errors.lines[index].so_hoa_don.message}
                    />
                  )}
              </td>
              <td>
                <Controller
                  control={control}
                  name={`lines.${index}.ngay_lap_hdon`}
                  render={({ field }) => (
                    <Flatpickr
                      {...field}
                      disabled={displaySearchInvoice || isDisableForm}
                      className="form-control d-block Flatpickr__Input"
                      placeholder="DD/MM/YYYY"
                      options={{
                        altInput: true,
                        altFormat: "d/m/Y",
                        dateFormat: "d/m/Y",
                        locale: {
                          ...Vietnamese,
                          firstDayOfWeek: 1,
                        },
                      }}
                      onChange={date => {
                        field.onChange(date);
                      }}
                    />
                  )}
                />
                {errors.lines &&
                  errors.lines[index] &&
                  errors.lines[index].ngay_lap_hdon && (
                    <MessageFormValidate
                      error={errors.lines[index].ngay_lap_hdon.message}
                    />
                  )}
              </td>
              <td>
                <input
                  disabled={isDisableForm}
                  type="text"
                  className={`form-control ${formValidate(
                    errors,
                    touchedFields,
                    `lines.${index}.ly_do`
                  )}`}
                  placeholder={t("placeholder.enter", {
                    title: t("form.ly_do"),
                  })}
                  {...register(`lines.${index}.ly_do`)}
                />
                {errors.lines &&
                  errors.lines[index] &&
                  errors.lines[index].ly_do && (
                    <MessageFormValidate
                      error={errors.lines[index].ly_do.message}
                    />
                  )}
              </td>
              <td>
                <React.Fragment>
                  <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                    {displaySearchInvoice && !isDisableForm ? (
                      <React.Fragment>
                        {fields.length >= 1 && (
                          <i
                            onClick={() => {
                              removeDataSearchInvoice(index);
                              remove(index);
                            }}
                            className="fas fa-trash fa-lg text-danger"
                            style={{ cursor: "pointer" }}
                          />
                        )}
                      </React.Fragment>
                    ) : (
                      <React.Fragment>
                        {fields.length > 1 && !isDisableForm && (
                          <i
                            onClick={() => {
                              remove(index);
                            }}
                            className="fas fa-trash fa-lg text-danger"
                            style={{ cursor: "pointer" }}
                          />
                        )}

                        {index === fields.length - 1 && !isDisableForm && (
                          <i
                            onClick={addNewLine}
                            className="fas fa-plus fa-lg text-success"
                            style={{ cursor: "pointer" }}
                          ></i>
                        )}
                      </React.Fragment>
                    )}
                  </div>
                </React.Fragment>
              </td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
  const titleCreate = isTaxDeduct
    ? t("title.create_tax_deduct")
    : t("title.create");

  useEffect(() => {
    // Set giá trị từ detailData
    if (
      detailData &&
      errorInvoicesListTypeInvoice?.items?.length > 0 &&
      errorInvoicesListNotificationProperties?.items?.length > 0
    ) {
      console.log(
        "🚀 ~ errorInvoicesListTypeInvoice:",
        errorInvoicesListTypeInvoice
      );
      console.log("🚀 ~ detailData:", detailData);
      //   reset();
      // Loại chứng từ *
      const ladhddt = errorInvoicesListTypeInvoice.items.find(
        item =>
          item.id === (isTaxDeduct ? detailData.lctdt : detailData.ladhddt)
      );
      if (ladhddt) {
        const loaiHoaDon = {
          value: ladhddt.id,
          label: ladhddt.value,
        };
        setValue("loai_hoa_don", loaiHoaDon);
        checkLoaiHoaDonHandler(loaiHoaDon);
      }
      // Loại thông báo *
      const loai_thong_bao = errorInvoicesLoaiThongBao.find(
        item => Number(item.value) === Number(detailData.loai)
      );
      if (loai_thong_bao) {
        setValue("loai_thong_bao", loai_thong_bao);
        checkThongBaoHandler(loai_thong_bao);
      }
      // Số thông báo
      if (detailData.so) {
        setValue("so_thong_bao", detailData.so);
      }
      // Ngày thông báo
      if (detailData.ntbccqt) {
        setValue("ngay_thong_bao", [new Date(detailData.ntbccqt)]);
      }

      // lines
      // id_invoice :item.KHHDon,khhdon ,ly_do ,ma_cqt_cap , so_hoa_don ,tchat_thong_bao
      // ngay_lap_hdon
      // tchat_thong_bao ,khmhdon

      // setTimeout(() => {
      //   checkLoaiHoaDonHandler();
      // });
      let lines = [];
      let listSearchInvoice = [];
      // Danh sách hóa đơn
      if (detailData.dshdon && detailData.dshdon.length > 0) {
        lines = detailData.dshdon.map(item => {
          const tchatThongbao =
            errorInvoicesListNotificationProperties.items.find(
              f => Number(f.id) === Number(item.TCTBao)
            );
          const khmhdon = KyHieuMauHoaDonList.find(
            f => Number(f.value) === Number(item.KHMSHDon)
          );
          return {
            id_invoice: item.Id,
            khhdon: item.KHHDon,
            ly_do: item.LDo,
            ma_cqt_cap: item.MCQTCap,
            so_hoa_don: item.SHDon,
            ngay_lap_hdon: [new Date(item.Ngay)],
            tchat_thong_bao: {
              value: tchatThongbao?.id,
              label: tchatThongbao?.value,
            },
            khmhdon: khmhdon,
          };
        });
        listSearchInvoice = detailData.dshdon.map(item => {
          return {
            id: item.Id,
            nban_mst: item.MCQTCap,
            ttchung_khmshdon: item.KHMSHDon,
            ttchung_khhdon: item.KHHDon,
            ttchung_shdon: item.SHDon,
            ttchung_nlap: new Date(item.Ngay).getTime() / 1000,
          };
        });
        setValue("lines", lines, { shouldValidate: true });
        if (Number(ladhddt.id) === 1) {
          setDataSearchInvoice(listSearchInvoice);
        }
      } else if (detailData.dsctu && detailData.dsctu.length > 0) {
        // Danh sách chứng từ
        lines = detailData.dsctu.map(item => {
          const khmsctu = KyHieuMauCTUList.find(
            f => Number(f.value) === Number(item.KHMSCTu)
          ) || {
            value: item.KHMSCTu,
            label: item.KHMSCTu,
          };
          return {
            id_invoice: item.Id,
            khhdon: item.KHCTu,
            ly_do: item.LDo,
            so_hoa_don: item.SCTu,
            ngay_lap_hdon: [new Date(item.NLap)],
            khmhdon: khmsctu,
          };
        });
        listSearchInvoice = detailData.dsctu.map(item => {
          return {
            id: item.Id,
            // nban_mst: item.MCQTCap,
            ttchung_khmshdon: item.KHMSCTu,
            ttchung_khhdon: item.KHCTu,
            ttchung_shdon: item.SCTu,
            ttchung_nlap: new Date(item.NLap).getTime() / 1000,
          };
        });
        setValue("lines", lines, { shouldValidate: true });
        if (Number(ladhddt.id) === 1) {
          setDataSearchInvoice(listSearchInvoice);
        }
      } else {
        setDataSearchInvoice([]);
      }
    } else {
    }
  }, [
    detailData,
    errorInvoicesListTypeInvoice,
    errorInvoicesListNotificationProperties,
  ]);

  return (
    <React.Fragment>
      <div className={`${detailData ? "" : "page-content"}`}>
        {!detailData && (
          <>
            <MetaTags>
              <title>{titleCreate}</title>
            </MetaTags>
          </>
        )}

        <div className="container-fluid">
          {!detailData && (
            <>
              <BreadcrumbWithLink
                title={
                  isTaxDeduct ? t("title.create_tax_deduct") : t("title.create")
                }
                breadcrumbItems={[
                  {
                    name: isTaxDeduct
                      ? t("title.manager_tax_deduct")
                      : t("title.manager"),
                  },
                  {
                    name: isTaxDeduct
                      ? t("title.create_tax_deduct")
                      : t("title.create"),
                  },
                ]}
              />
            </>
          )}

          <Row className="row-cols-1">
            {/* Modal START*/}
            <Col>
              {/* Search Invoice Modal */}
              <SearchInvoiceTaxDeduct
                isTaxDeduct={isTaxDeduct}
                // dataDetail={dataSelectTemplates}
                isOpenModal={searchInvoiceModal}
                toggleModal={toggleSearchInvoiceModal}
                dataSearchInvoice={dataSearchInvoice}
                setDataSearchInvoice={setDataSearchInvoice}
                addNewLine={addNewLine}
              />
            </Col>
            {/* Modal E N D*/}
            <Col>
              <Card>
                <CardBody>
                  <Row className="row-cols-1 row-cols-md-2">
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="loai_hoa_don">
                          {isTaxDeduct
                            ? t("form.loai_chung_tu")
                            : t("form.loai_hoa_don")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="loai_hoa_don"
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder={t("placeholder.select", {
                                title: isTaxDeduct
                                  ? t("form.loai_chung_tu")
                                  : t("form.loai_hoa_don"),
                              })}
                              options={optionLoaiHoaDon}
                              isDisabled={
                                loadingListTypeInvoice || isDisableForm
                              }
                              onChange={data => {
                                field.onChange(data);
                                checkLoaiHoaDonHandler(
                                  getValues("loai_hoa_don")
                                );
                              }}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.loai_hoa_don && (
                          <MessageFormValidate
                            error={errors.loai_hoa_don.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    <Col>
                      <FormGroup className="mb-3">
                        <Label htmlFor="loai_thong_bao">
                          {t("form.loai_thong_bao")}{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Controller
                          control={control}
                          name="loai_thong_bao"
                          render={({ field }) => (
                            <Select
                              {...field}
                              placeholder={t("placeholder.select", {
                                title: t("form.loai_thong_bao"),
                              })}
                              options={
                                errorInvoicesLoaiThongBao &&
                                errorInvoicesLoaiThongBao.length > 0
                                  ? errorInvoicesLoaiThongBao.map(item => ({
                                      value: item.value,
                                      label: item.label,
                                    }))
                                  : []
                              }
                              onChange={data => {
                                field.onChange(data);
                                checkThongBaoHandler(
                                  getValues("loai_thong_bao")
                                );
                              }}
                              isDisabled={isDisableForm}
                              classNamePrefix="select2-selection"
                            />
                          )}
                        />
                        {errors.loai_thong_bao && (
                          <MessageFormValidate
                            error={errors.loai_thong_bao.message}
                          />
                        )}
                      </FormGroup>
                    </Col>
                    {displayThongBao && (
                      <React.Fragment>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="so_thong_bao">
                              {t("form.so_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "so_thong_bao"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.so_thong_bao"),
                              })}
                              disabled={isDisableForm}
                              {...register("so_thong_bao")}
                            />
                            {errors.so_thong_bao && (
                              <MessageFormValidate
                                error={errors.so_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="ngay_thong_bao">
                              {t("form.ngay_thong_bao")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <Controller
                              control={control}
                              name="ngay_thong_bao"
                              render={({ field }) => (
                                <Flatpickr
                                  {...field}
                                  className="form-control d-block Flatpickr__Input"
                                  placeholder="DD/MM/YYYY"
                                  options={{
                                    altInput: true,
                                    altFormat: "d/m/Y",
                                    dateFormat: "d/m/Y",
                                    locale: {
                                      ...Vietnamese,
                                      firstDayOfWeek: 1,
                                    },
                                  }}
                                  disabled={isDisableForm}
                                  onChange={date => {
                                    field.onChange(date);
                                  }}
                                />
                              )}
                            />
                            {errors.ngay_thong_bao && (
                              <MessageFormValidate
                                error={errors.ngay_thong_bao.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </React.Fragment>
                    )}
                  </Row>
                  {displaySearchInvoice && !isDisableForm && (
                    <Row className="mb-2">
                      <Col>
                        <button
                          type="button"
                          className="btn btn-primary btn-label"
                          onClick={() => {
                            toggleSearchInvoiceModal();
                          }}
                        >
                          <i className="fas fa-search-plus label-icon" />
                          {isTaxDeduct
                            ? t("form.search_tax_deduct")
                            : t("form.search_invoice")}
                        </button>
                      </Col>
                    </Row>
                  )}
                  <div className="custom-table-border">
                    {tableTaxDeduct}
                    {errors.lines && (
                      <MessageFormValidate error={errors.lines.message} />
                    )}
                  </div>
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      {!detailData ? (
                        <Link
                          to={`/${
                            isTaxDeduct ? "error-tax-deducts" : "error-invoices"
                          }`}
                          className="btn btn-danger btn-label"
                        >
                          <i className="fas fa-undo label-icon"></i>
                          {t("form.cancel")}
                        </Link>
                      ) : (
                        <Button
                          color="danger"
                          className="btn-label"
                          type="button"
                          onClick={() => {
                            if (toggleDetail) {
                              toggleDetail();
                            }
                          }}
                          disabled={
                            loadingCreate || buStoreHeader === ALL_STORE
                          }
                        >
                          <i className="fas fa-undo label-icon"></i>
                          Đóng
                        </Button>
                      )}
                    </Col>
                    <Col className="col-auto">
                      {!isDisableForm && (
                        <Button
                          color="primary"
                          className="btn-label"
                          type="button"
                          onClick={() => {
                            handleSubmit(onSubmit, onErrorInvoice)();
                          }}
                          disabled={
                            loadingCreate ||
                            loadingEdit ||
                            buStoreHeader === ALL_STORE
                          }
                        >
                          <i className="far fa-save label-icon"></i>
                          {t("form.save")}
                        </Button>
                      )}
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

CreateErrorTaxDeduct.propTypes = {
  toggleDetail: PropTypes.func,
  detailData: PropTypes.any,
  isTaxDeduct: PropTypes.bool,
};

export default CreateErrorTaxDeduct;
